module.exports = __webpack_public_path__ + "frxx/img/entry.45ce696.mp4";